/*globals window,document,jQuery */
var CJ = ( function ( parent, $ ) {
	'use strict';

	var globals = parent.globals || {},
		filters = parent.filters || {},
		fn = parent.fn || {};

	var debug = false;

	/* ======================== Start: Editable Content Below ======================== */



	// global entry for navburger control
	$( '.navbar .hamburger' ).on( 'click', function ( e ) {
		var $this = $( this );
		if ( $this.hasClass( 'active' ) ) {
			$this.removeClass( 'active' );
		} else {
			$this.addClass( 'active' );
		}
	} );

	$( 'a.video-modal' ).on( 'click', function ( e ) {

		e.preventDefault();

		var $this = $( this );
		var src = $this.attr( 'href' );

		$( '#videoModal' ).modal( 'show' );
		$( '#videoModal iframe' ).attr( 'src', src );

  });

  if (navJS && navJS.isIOS()) {
    $('.btn-download,.btn-get-started').attr('href', 'https://apps.apple.com/us/app/picticular/id1490417069')
  } else if (navJS && navJS.isAndroid()) {
    $('.btn-download,.btn-get-started').attr('href', 'https://play.google.com/store/apps/details?id=com.innovatorm.picticulardev2')
  }

	$( '#videoModal button' ).click( function () {
		$( '#videoModal iframe' ).removeAttr( 'src' );
	} );


	/* ============================ End: Editable Content ============================ */

	// update any parent stuff and return
	parent.globals = globals;
	parent.filters = filters;
	parent.fn = fn;
	return parent;

}( CJ || {}, jQuery ) );
